module.exports = __webpack_public_path__ + "static/media/opt_in_for_more_icon.9aa75924.png";